import React from 'react';
import { useGoogleTranslateBlocking } from '../hooks/useGoogleTranslateBlocking';

interface GoogleTranslateBlockerProps {
  children: React.ReactNode;
  enableLogging?: boolean;
}

/**
 * GoogleTranslateBlocker - Component wrapper for Google Translate blocking functionality
 * Must be used inside LanguageProvider context
 */
export const GoogleTranslateBlocker: React.FC<GoogleTranslateBlockerProps> = ({ 
  children, 
  enableLogging = false 
}) => {
  // Use the Google Translate blocking hook
  useGoogleTranslateBlocking({
    enableDynamicLanguage: true,
    logActivity: enableLogging
  });

  // This component is invisible - just provides the blocking functionality
  return <>{children}</>;
};

export default GoogleTranslateBlocker; 